import { createSelector } from 'reselect';

const optimizelyReduxStateSelector = state => state.optimizely;

export const selectOptimizely = createSelector(optimizelyReduxStateSelector, optimizely => optimizely || {});

export const selectOptimizelyIsAvailable = createSelector(selectOptimizely, optimizely => optimizely.isAvailable);
